export default "__VITE_ASSET__CFYuhf3v__"